// Route the clickable coverage badge navigates to (add / update insurance).
// Shared here so the template and its spec reference one source of truth.
export const ADD_INSURANCE_ROUTE = '/profile/insurance';

export enum CoverageBadgeType {
  IN_NETWORK = 'in-network',
  OUT_OF_NETWORK = 'out-of-network',
  SELF_PAY = 'self-pay',
  COVERAGE_NOT_STARTED = 'coverage-not-started',
  COVERAGE_ENDED = 'coverage-expired',
  COVERAGE_UNVERIFIED = 'coverage-unverified',
  NONE = 'none',
}

export type CoverageInfo = {
  badgeType: CoverageBadgeType;
  insuranceName: string;
  isSelfPay: boolean;
};
